export default {
  computed: {
    calendarLocale() {
      return {
        days: [
          this.$t('calendar.days.sun'),
          this.$t('calendar.days.mon'),
          this.$t('calendar.days.tue'),
          this.$t('calendar.days.wed'),
          this.$t('calendar.days.thu'),
          this.$t('calendar.days.fri'),
          this.$t('calendar.days.sat')
        ],
        months: [
          this.$t('calendar.months.jan'),
          this.$t('calendar.months.feb'),
          this.$t('calendar.months.mar'),
          this.$t('calendar.months.apr'),
          this.$t('calendar.months.may'),
          this.$t('calendar.months.jun'),
          this.$t('calendar.months.jul'),
          this.$t('calendar.months.aug'),
          this.$t('calendar.months.sep'),
          this.$t('calendar.months.oct'),
          this.$t('calendar.months.nov'),
          this.$t('calendar.months.dec')
        ],
        pickers: [
          this.$t('Next 7 days'),
          this.$t('Next 30 days'),
          this.$t('Previous 7 days'),
          this.$t('Prevoius 30 days')
        ],
        placeholder: {
          date: this.$t('Select Date'),
          dateRange: this.$t('Select Date Range')
        }
      }
    },
    calendarFormat() {
      return this.$i18n.locale === 'pl' ? 'DD.MM.YYYY' : 'DD MMM YYYY'
    }
  }
}
